export function getBackDestination(path: string): string {
    if (!location) {
        return '/';
    }

    if (path.startsWith('/reservation-with-fee')) {
        return '/customise-booking';
    }

    switch (path) {
        case '/':
            return '/';

        case 'unit-listing':
            return '/';

        case 'book-unit':
            if (window.rapidstor_settings.app_config.pages.storageType) {
                return '/unit-listing';
            } else {
                return '/';
            }

        case '/customise-booking':
            return '/book-unit';

        case '/booking-confirmed':
            return '/';

        default:
            return '/';
    }
}